export default __webpack_public_path__ + "static/media/Spinner-1s-200px.8a76f01e.gif";